// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__lswYw","validationTips":"StatementDescriptor_validationTips__1vRaB"};